function generateSecurePassword(length = 8) {
  const upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowerCase = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const specialChars = "!@#$%^&*()-_";

  if (length < 8) length = 8;

  const getRandomChar = (chars) => chars[Math.floor(Math.random() * chars.length)];

  let password = [
    getRandomChar(upperCase),
    getRandomChar(lowerCase),
    getRandomChar(numbers),
    getRandomChar(specialChars),
  ];

  const allChars = upperCase + lowerCase + numbers + specialChars;

  while (password.length < length) {
    password.push(getRandomChar(allChars));
  }

  password = password.sort(() => Math.random() - 0.5);

  return password.join('');
}

export default generateSecurePassword;
